import { TreeProps } from "./Tree"
import { FocusEvent, useContext, useEffect, useState } from "react"
import { TreeContext } from "./TreeProvider"
import * as React from "react";

const UpdateIconMap = {
    's_id': 'diagram-2',
    'element_name': 'tag',
    'element_description': 'text-paragraph',
    'element_definition': 'question-circle',
    'scoring_scale': 'list-ol'
}
const StatusIconMap = {
    'legacy': 'hourglass-bottom orange',
    'new': 'plus-circle purple'
}

export const ChangeCell = ({mapping, updated, related, status, row_id, style}) => {
    let map_labels = related?.map(e_id => <button className={`d-flex border-0 bg-${mapping === "replaced" ? 'orange' : 'purple'} white fs-6 px-1 rounded`}
                                                 key={row_id + '_' + e_id}>{e_id}</button>)
    let label_icons = updated?.map(change => <i className={`bi bi-${UpdateIconMap[change]} fs-4`} key={row_id + '_' + UpdateIconMap[change]}/>)

    let status_icon = undefined
    if (status !== undefined && status !== 'current') {
        status_icon = <i className={`bi bi-${StatusIconMap[status]} fs-5`} style={{paddingTop: '1px'}}
                         key={row_id + '_status'}/>
    }
    return <div className="a-middle gap-1 flex-wrap" key={row_id} style={style}>{status_icon} {map_labels} {label_icons} </div>
}

const TreeCell = ({
  type,
  width,
  value,
  className,
  setProps,
  field,
  id,
  index,
}: {
  type: string
  width: number
  value: string | number | boolean
  className: string
  setProps: (props: Partial<TreeProps>) => void
  field: string
  id: number
  index: number
}) => {
  const style = { width: width, height: "30px" }
  const [editableValue, setEditableValue] = useState(value)
  const { nCustom } = useContext(TreeContext)

  useEffect(() => {
    setEditableValue(value)
  }, [value])

  const handle_change = (e: FocusEvent<HTMLInputElement>) => {
    if (e.target.value != value) {
      setProps({
        n_custom: nCustom + 1,
        modified_field: field,
        entry_id: id,
        entry_index: index,
        modified_value: e.target.value,
      })
    }
  }

  if (type === "input-number") {
    return (
      <input
        type="number"
        step="0.01"
        min="0"
        value={editableValue as number}
        onChange={(e) => setEditableValue(e.target.value)}
        style={style}
        className={className}
        onBlur={(e) => handle_change(e)}
      />
    )
  } else if (type === "input-number-highlight") {
    return (
      <input
        type="number"
        step="0.01"
        min="0"
        value={editableValue as number}
        onChange={(e) => setEditableValue(e.target.value)}
        style={style}
        className={className}
        onBlur={(e) => handle_change(e)}
      />
    )
  } else if (type === "score") {
    const benchmark_class: { [punctuation: number]: string } = {
      0: `benchmark-score below`,
      1: `benchmark-score at`,
      2: `benchmark-score above`,
      3: `benchmark-score above`,
    }
    return (
      <div style={style} className={className}>
        <span className={benchmark_class[value as number]}></span>
        {value === 3 && (
          <div className="d-flex benchmark-score top md-benchmark_top">
            <i className="bi bi-bookmark-fill" />
          </div>
        )}
      </div>
    )
  } else if (type === "update") {
    const updates = JSON.parse(value as string)
    return (
      <ChangeCell mapping={updates.mapping_type} updated={updates.updated} related={updates.related}
                  status={updates.status} row_id={id} style={style}/>
    )
  }
  return (
    <div style={style} className={className}>
      {value}
    </div>
  )
}

export default TreeCell
